import PMBProjectSelections from 'components/PMBProjectSelections'
import ModalAddProject from 'features/private-views/project/ModalAddProject'
import { setIsModalOpenAddProject } from 'features/private-views/project/projectSlice'
import { useEffect, useRef, useState } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import {
  Card,
  CardBody,
  CardTitle,
  Col,
  FormGroup,
  Input,
  Label,
  Row,
  Spinner,
} from 'reactstrap'
import {
  setOrdersCustomTrx,
  setOrdersNote,
  setProject,
  setRemoveDoc,
} from '../purchaseCommoditySlice'
import { uploadFile } from '../purchaseCommodityAction'
import CustomButton from 'components/Buttons/CustomButton'
import { URL_PROJECTS_MENU } from 'utils/pathUrl'
import { ExternalLink, FilePlus, X } from 'react-feather'
import { useSnackbar } from 'notistack'

const NoteInfo = ({ fileNames = [], setFileNames }) => {
  const fileInputRef = useRef(null)
  const dispatch = useDispatch()
  const { orders } = useSelector((state) => state.purchaseCommmodity)
  const { isModalOpenAddProject } = useSelector((e) => e.project)
  const [selectedProject, setSelectedProject] = useState(null)
  const [isUploading, setIsUploading] = useState(false)
  const { enqueueSnackbar } = useSnackbar()

  const handleFileChange = async (e) => {
    setIsUploading(true)
    const newFiles = []

    for (let i = 0; i < e.target.files.length; i++) {
      const file = e.target.files[i]
      const fileId = `${Date.now()}-${i}-${Math.random().toString(36).substring(2, 7)}`

      const isDuplicate = (fileNames || []).some(
        (existingFile) =>
          existingFile.fileName === file.name &&
          existingFile.fileSize === file.size,
      )
      if (isDuplicate) {
        enqueueSnackbar(
          `File dengan nama "${file?.name}" sudah diunggah sebelumnya.`,
          {
            variant: 'error',
          },
        )
        continue
      }

      try {
        const uploadRes = await dispatch(uploadFile(file)).unwrap()
        const uploadedUrl =
          uploadRes?.url ||
          uploadRes?.data?.url ||
          (typeof uploadRes === 'string' ? uploadRes : '')

        if (!uploadedUrl) {
          throw new Error(
            'Respon server upload tidak memiliki URL file yang valid',
          )
        }

        const tempFile = {
          id: fileId,
          fileName: file.name,
          fileSize: file.size,
          url: uploadedUrl,
        }
        newFiles.push(tempFile)
      } catch (error) {
        enqueueSnackbar(
          `Gagal mengunggah file ${file.name}: ${error?.message || error}`,
          {
            variant: 'error',
          },
        )
      }
    }

    setFileNames?.((prev) => [...(prev || []), ...newFiles])
    setIsUploading(false)
    e.target.value = null
  }

  const handleChange = (e) => {
    dispatch(setOrdersNote(e.target.value))
  }

  const handleChangeCustomNumber = (e) => {
    dispatch(setOrdersCustomTrx(e.target.value))
  }

  const handleSelectedProject = (project) => {
    setSelectedProject(project)
    dispatch(setProject(project))
  }

  const toggleOpenCloseAddProject = () => {
    dispatch(setIsModalOpenAddProject(!isModalOpenAddProject))
  }

  useEffect(() => {
    if (orders?.project && !selectedProject) {
      setSelectedProject(orders.project)
    }
  }, [orders?.project])

  return (
    <Card body className="custom-container m-0 m-auto border-0 shadow-sm">
      <ModalAddProject
        isOpen={isModalOpenAddProject}
        toggle={toggleOpenCloseAddProject}
        isOutsideProject
      />
      <CardBody className="p-4">
        <Row>
          <Col>
            <CardTitle tag="h5" className="mb-4">
              Informasi Lainnya
            </CardTitle>
            <FormGroup>
              <Label>Project (opsional)</Label>
              <PMBProjectSelections
                style={{ borderColor: 'white', caretColor: 'transparent' }}
                className="border-input button w-100"
                placeholder="Pilih project"
                value={selectedProject}
                onChange={handleSelectedProject}
                testId="purchase-form-project-select"
              />
              {selectedProject && (
                <CustomButton
                  onClick={() =>
                    window.open(
                      `${URL_PROJECTS_MENU}/${selectedProject.id}?tab=summary`,
                      '_blank',
                    )
                  }
                  size="sm"
                  color="primary"
                  className="mt-2"
                  outline
                >
                  <span className="d-flex align-items-center gap-1">
                    Lihat detail Project <ExternalLink size={17} />
                  </span>
                </CustomButton>
              )}
            </FormGroup>
            <FormGroup>
              <Label>Nomor transaksi (opsional)</Label>
              <Input
                id="customNoTrx"
                name="customNoTrx"
                placeholder="Masukkan nomor transaksi"
                value={orders?.order?.transaction_number}
                onChange={(e) => handleChangeCustomNumber(e)}
              />
              <small className="text-muted">
                Silakan tambahkan jika Anda memiliki penomoran transaksi sendiri
              </small>
            </FormGroup>
            <FormGroup>
              <Label>Catatan ke penjual (opsional)</Label>
              <Input
                id="note"
                name="note"
                placeholder="Masukkan catatan jika ada"
                type="textarea"
                style={{ minHeight: '128px' }}
                value={orders?.order?.note}
                onChange={(e) => handleChange(e)}
              />
            </FormGroup>
            <FormGroup>
              <Label>Dokumen tambahan (opsional)</Label>
              <Input
                type="file"
                innerRef={fileInputRef}
                style={{ display: 'none' }}
                onChange={handleFileChange}
                accept=".png, .jpeg, .jpg, .pdf, .xlsx, .xls, .doc, .docx"
                multiple
                disabled={isUploading}
              />
              <div className="d-flex flex-column text-wrap w-auto">
                <div
                  className="border border-1 rounded mb-1 d-flex align-items-center"
                  style={{ padding: '12px 20px' }}
                >
                  <FilePlus
                    size={18}
                    className="me-2"
                    style={{
                      color: isUploading ? '#D0D5DD' : '#101828',
                      cursor: isUploading ? 'not-allowed' : 'pointer',
                    }}
                    onClick={() => fileInputRef.current.click()}
                  />

                  <div
                    className="text-sm fw-bold flex-grow-1"
                    style={{
                      color: isUploading ? '#D0D5DD' : '#101828',
                    }}
                  >
                    {isUploading ? (
                      <>
                        <Spinner size="sm" className="ms-2" /> Uploading ...
                      </>
                    ) : fileNames?.length > 0 ? (
                      fileNames.map((e, i) => (
                        <span className="ms-3 badge-line" key={e.id || i}>
                          {e.fileName}
                          <X
                            size={16}
                            style={{ cursor: 'pointer' }}
                            onClick={() => {
                              const filteredFileNames = fileNames.filter(
                                (file) => file.id !== e.id,
                              )
                              setFileNames?.(filteredFileNames)
                              dispatch(
                                setRemoveDoc({
                                  url: e.url,
                                  id: e.id,
                                  index: i,
                                }),
                              )
                            }}
                          />
                        </span>
                      ))
                    ) : (
                      <span
                        onClick={() => fileInputRef.current.click()}
                        style={{
                          cursor: isUploading ? 'not-allowed' : 'pointer',
                        }}
                      >
                        Unggah Dokumen
                      </span>
                    )}
                  </div>
                </div>

                <span className="text-sm text-muted">
                  Jenis file yang bisa berupa .png, .jpeg, .jpg, .pdf, .xlsx,
                  .xls, .doc, .docx
                </span>
              </div>
            </FormGroup>
          </Col>
        </Row>
      </CardBody>
    </Card>
  )
}

export default NoteInfo
